import { Route } from '@angular/router'
import { accessGuard } from '@mattrika/benefit-core'

export const ClientRoutes: Route[] = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
        path: 'dashboard',
        canActivate: [
            accessGuard({
                requireGroups: ['client'],
                requireOwner: false,
                options: { redirectTo: ['/client-admin'] },
            }),
        ],
        loadComponent: () =>
            import('./page-client/page-client.component').then(
                (c) => c.PageClientComponent,
            ),
        data: { pageTitle: 'Member Dashboard' },
    },
    {
        path: 'client-admin',
        canActivate: [
            accessGuard({
                requireGroups: ['client'],
                requireOwner: true,
                options: { redirectTo: ['/client/dashboard'] },
            }),
        ],
        loadComponent: () =>
            import('./page-client-admin/page-client-admin.component').then(
                (c) => c.PageClientAdminComponent,
            ),
        data: { pageTitle: 'Client Admin Dashboard' },
    },
    {
        path: 'users',
        canActivate: [
            accessGuard({
                requireGroups: ['client'],
                requireOwner: true,
                options: { redirectTo: ['/client/dashboard'] },
            }),
        ],
        loadComponent: () =>
            import('./page-client-users/page-client-users.component').then(
                (c) => c.PageClientUsersComponent,
            ),
        data: { pageTitle: 'All Users' },
    },
    {
        path: 'signup-access-control',
        canActivate: [
            accessGuard({
                requireGroups: ['client'],
                requireOwner: true,
                options: { redirectTo: ['/client/dashboard'] },
            }),
        ],
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./page-signup-access-control/page-signup-access-control.component').then(
                        (c) => c.PageSignupAccessControlComponent,
                    ),
                data: { pageTitle: 'Signup Access Control' },
            },
            {
                path: 'manage-list',
                loadComponent: () =>
                    import('./page-signup-access-control/page-manage-list/page-manage-list.component').then(
                        (c) => c.PageManageListComponent,
                    ),
                data: { pageTitle: 'Manage List' },
            },
        ],
    },
    {
        path: 'deals',
        redirectTo: '/home',
        pathMatch: 'full',
    },
    {
        path: 'category/:slug',
        loadComponent: () =>
            import('./page-category/page-category.component').then(
                (c) => c.PageCategoryComponent,
            ),
    },
    {
        path: 'product/:id',
        loadComponent: () =>
            import('./page-product-detail/page-product-detail.component').then(
                (c) => c.PageProductDetailComponent,
            ),
    },
    {
        path: 'profile',
        canActivate: [accessGuard({ requireGroups: ['client'] })],
        loadComponent: () =>
            import('./page-profile/page-profile.component').then(
                (c) => c.PageProfileComponent,
            ),
    },
    {
        path: 'offer/:id',
        loadComponent: () =>
            import('./page-offer-detail/page-offer-detail.component').then(
                (c) => c.PageOfferDetailComponent,
            ),
    },
    {
        path: 'claimed-items',
        canActivate: [accessGuard({ requireGroups: ['client'] })],
        loadComponent: () =>
            import('./page-claimed-items/page-claimed-items.component').then(
                (c) => c.PageClaimedItemsComponent,
            ),
    },
    {
        path: 'raffle',
        canActivate: [accessGuard({ requireGroups: ['client'] })],
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./page-raffle-dashboard/page-raffle-dashboard.component').then(
                        (c) => c.PageRaffleDashboardComponent,
                    ),
                data: { pageTitle: 'Raffle Dashboard' },
            },
            {
                path: 'winners',
                loadComponent: () =>
                    import('./page-raffle-winners/page-raffle-winners.component').then(
                        (c) => c.PageRaffleWinnersComponent,
                    ),
                data: { pageTitle: 'Raffle Winners' },
            },
        ],
    },
]
